import { render, staticRenderFns } from "./NoTransactionFilter.vue?vue&type=template&id=ff510e94&scoped=true&"
import script from "./NoTransactionFilter.vue?vue&type=script&lang=js&"
export * from "./NoTransactionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff510e94",
  null
  
)

export default component.exports